import PersonIcon from '@mui/icons-material/Person';
import CakeIcon from '@mui/icons-material/Cake';
import WcIcon from '@mui/icons-material/Wc';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import MobileScreenShareIcon from '@mui/icons-material/MobileScreenShare';
import EmailIcon from '@mui/icons-material/Email';
import HomeIcon from '@mui/icons-material/Home';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import MarkunreadMailboxIcon from '@mui/icons-material/MarkunreadMailbox';
  
  
  export const  personalInfo={
    "Full Name": "Rutuja",
    "Birth Date": "1/3/2020",
    Email :"Ritwi.m@gmail.com",
    Gender: "Female",
    "Mobile Number":"9445612384",
     Address: "Mr./Ms. John Doe, 123 Main Street, Near City Market, Nagpur, Maharashtra - 424002"

  }

 export const  storeInfo={
    "Store Name": "Elegant Styles",
    "Store Address":"Mr./Ms. John Doe 123 Main Street Near City Market Nagpur, Maharashtra 4 xyzhg.b@hzgdsahd.com",
    "Store Contact no.": "Mumbai",
    "Store license number": "12/12/2022",
    "Store hours":""
  }

   export const  otherInfo={
    "Vehicle type": "Two Wheeler",
    "License Plate Number": "JSGH456252214",
  }

  export const  bankDetails={
    "Account Number": "457896314566",
    "Account Name": "Saving account",
    "Bank Name":"State Bank of India ",
    "Routing Number": "SHGF654656"
  }

    export const  document={

  }

    export const  servicesOffered={
 
  }


  export const iconMap = {
  "Full Name": PersonIcon,
  "Birth Date": CakeIcon,
  "Gender": WcIcon,
  "Phone": PhoneIphoneIcon,
  "Mobile Number": MobileScreenShareIcon,
  "Email": EmailIcon,
  "Address": HomeIcon,
  // "City": LocationCityIcon,
  // "State": HomeIcon,
  // "Zip Code": MarkunreadMailboxIcon,
};

